export default __webpack_public_path__ + "static/Polychain-86b1363e2f6c177817b611d2613b6527.png";